import axios from '../api/axios';
import { baseURL } from '../config/url';

const registerUrl = baseURL + '/users/public/register';

const registerReq = async (payload) => {
  return axios.post(registerUrl, payload);
};

export default { registerReq };
